module.exports = __webpack_public_path__ + "static/img/bg_mod_education.c86bb232.jpg";